import { render, staticRenderFns } from "./CustomerCart.vue?vue&type=template&id=8f7422a0&lang=pug&"
import script from "./CustomerCart.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomerCart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CustomerCart.vue?vue&type=style&index=0&id=8f7422a0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports